/**
 * CANAL DE SUPPORT DE RECTORIUM CORPORATION — une seule source.
 *
 * L'adresse et le numéro étaient écrits en toutes lettres dans dix-sept textes de l'aide, dans la vue
 * d'assistance et dans le module d'aide ; le numéro est celui d'un seul pays alors que Rectorium OS est
 * une application monde (écart T-6 du programme de supériorité).
 *
 * DÉCISION RÉSERVÉE À ALFRED : le canal de support de Rectorium Corporation (adresse, numéro
 * international, chat). Le numéro ci-dessous est conservé TEL QUEL tant qu'il n'a pas tranché, pour que
 * l'affichage des établissements ne change pas : il suffit désormais de le changer ICI. Les textes de
 * l'aide le lisent par les variables d'interpolation `{{support_email}}` et `{{support_phone}}`
 * (posées par défaut dans `i18n/index.js`).
 */
export const SUPPORT_EMAIL = 'support@rectorium.com';
export const SUPPORT_PHONE = '+237 698 57 82 66';
